import {useTranslation} from 'react-i18next'
import {useAuth} from '../../../app/modules/auth'

const campusFollowText = {
  1: 'LABEL.FOLLOW_SWISS_UMEF',
  17: 'LABEL.FOLLOW_DAKAR_UMEF',
}

const campusMedia = {
  1: [
    {
      name: 'Facebook',
      link: 'https://www.facebook.com/SwissUmefGeneva/',
      bgColor: '#4267B2',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' />
        </svg>
      ),
    },
    {
      name: 'Instagram',
      link: 'https://www.instagram.com/SwissUmefGeneva/',
      bgColor: '#8a3ab9',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <rect x='2' y='2' width='20' height='20' rx='5' ry='5' />
          <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' />
          <line x1='17.5' y1='6.5' x2='17.51' y2='6.5' />
        </svg>
      ),
    },
    {
      name: 'LinkedIn',
      link: 'https://www.linkedin.com/company/swissumefgeneva/',
      bgColor: '#0e76a8',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <path d='M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z' />
          <rect x='2' y='9' width='4' height='12' />
          <circle cx='4' cy='4' r='2' />
        </svg>
      ),
    },
    {
      name: 'X',
      link: 'https://twitter.com/SwissUmefGeneva',
      bgColor: '#000',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <path d='M4 4l16 16m0-16L4 20' />
        </svg>
      ),
    },
    {
      name: 'VK',
      link: 'https://vk.com/swissumef_gva',
      bgColor: '#4C75A3',
      icon: <i className='la la-vk text-white' style={{fontSize: 22}} />,
    },
    {
      name: 'YouTube',
      link: 'https://www.youtube.com/@SwissUmefGeneva',
      bgColor: '#c4302b',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <path d='M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z' />
          <polygon points='9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02' />
        </svg>
      ),
    },
  ],

  17: [
    {
      name: 'Facebook',
      link: 'https://www.facebook.com/people/SWISS-UMEF-University-Campus-Dakar/61577564364093/#',
      bgColor: '#4267B2',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <path d='M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' />
        </svg>
      ),
    },
    {
      name: 'Instagram',
      link: 'https://www.instagram.com/swissumefdakar/',
      bgColor: '#8a3ab9',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <rect x='2' y='2' width='20' height='20' rx='5' ry='5' />
          <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' />
          <line x1='17.5' y1='6.5' x2='17.51' y2='6.5' />
        </svg>
      ),
    },
    {
      name: 'LinkedIn',
      link: 'https://www.linkedin.com/company/swiss-umef-university-campus-dakar/',
      bgColor: '#0e76a8',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <path d='M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z' />
          <rect x='2' y='9' width='4' height='12' />
          <circle cx='4' cy='4' r='2' />
        </svg>
      ),
    },
    {
      name: 'YouTube',
      link: 'https://www.youtube.com/@SWISSUMEFUniversity-CampusDaka',
      bgColor: '#c4302b',
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='22'
          height='22'
          stroke='white'
          strokeWidth='2'
        >
          <path d='M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z' />
          <polygon points='9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02' />
        </svg>
      ),
    },
  ],
}

const SocialMedia = () => {
  const {t} = useTranslation()
  const {currentUser} = useAuth()

  const followKey = campusFollowText[currentUser?.campus_id] || 'LABEL.FOLLOW_UMEF'
  const mediaList = campusMedia[currentUser?.campus_id] || campusMedia[1] // fallback Geneva

  return (
    <div className='card'>
      <div className='card-body p-3'>
        <div className='d-flex align-items-center justify-content-between flex-wrap gap-3'>
          <div className='text-start'>
            <h2 className='fw-bold text-primary m-0'>{t(followKey)}</h2>
          </div>

          <div className='d-flex flex-wrap gap-3'>
            {mediaList.map((item, index) => (
              <a
                key={index}
                href={item.link}
                target='_blank'
                rel='noopener noreferrer'
                className='d-flex align-items-center justify-content-center rounded-circle shadow-sm'
                style={{
                  backgroundColor: item.bgColor,
                  width: '55px',
                  height: '55px',
                  transition: '0.3s',
                }}
              >
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SocialMedia
